import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import QueuePage              from './pages/QueuePage';
import PricingPage            from './pages/PricingPage';
import SettingsPage           from './pages/SettingsPage';
import { StatusPage }         from './pages/StatusPage';
import ScoringPage            from './pages/ScoringPage';
import ApprovedProductsPage   from './pages/ApprovedProductsPage';
import ImageSourcesPage       from './pages/ImageSourcesPage';
import { LoginPage }          from './pages/LoginPage';
import { AuthGuard }          from './components/AuthGuard';
import { isAuthenticated, clearAuth, getUsername } from './auth';

const NAV_ITEMS = [
  { to: '/',        label: 'Queue'    },
  { to: '/settings', label: 'Discovery' },
  { to: '/scoring',  label: 'Scoring'   },
  { to: '/approved', label: 'Approved'  },
  { to: '/pricing',  label: 'Pricing'   },
  { to: '/sources',  label: 'Sources'   },
  { to: '/status',   label: 'Status'    },
] as const;

function AppShell() {
  const navigate = useNavigate();

  function handleLogout() {
    clearAuth();
    navigate('/login', { replace: true });
  }

  return (
    <div style={styles.layout}>
      <header style={styles.header} className="app-header">
        <a href="/" style={styles.wordmark} className="app-wordmark">POSTERNAUTS AGENT</a>
        <nav className="app-nav">
          {NAV_ITEMS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              style={({ isActive }) => ({
                padding: '6px 14px',
                borderRadius: '6px',
                fontSize: '13px',
                fontWeight: 500,
                textDecoration: 'none',
                color: isActive ? '#fff' : '#888',
                background: isActive ? '#222230' : 'transparent',
                transition: 'all 0.15s',
              })}
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <div style={styles.userArea} className="app-user-area">
          <span style={styles.username} className="app-username">{getUsername()}</span>
          <button style={styles.logoutBtn} onClick={handleLogout}>
            Sign out
          </button>
        </div>
      </header>

      <main className="app-main">
        <Routes>
          <Route path="/"         element={<QueuePage />}           />
          <Route path="/pricing"  element={<PricingPage />}         />
          <Route path="/settings" element={<SettingsPage />}        />
          <Route path="/status"   element={<StatusPage />}          />
          <Route path="/scoring"  element={<ScoringPage />}         />
          <Route path="/approved" element={<ApprovedProductsPage />}/>
          <Route path="/sources"  element={<ImageSourcesPage />}    />
          <Route path="*"         element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={
        isAuthenticated()
          ? <Navigate to="/" replace />
          : <LoginPage />
      } />
      <Route path="/*" element={
        <AuthGuard>
          <AppShell />
        </AuthGuard>
      } />
    </Routes>
  );
}

const styles: Record<string, React.CSSProperties> = {
  layout: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
    padding: '0 2rem',
    height: '56px',
    background: '#111118',
    borderBottom: '1px solid #222230',
    flexShrink: 0,
  },
  wordmark: {
    fontSize: '15px',
    fontWeight: 700,
    letterSpacing: '0.04em',
    color: '#a0a8ff',
    textDecoration: 'none',
  },
  nav: {
    // handled by .app-nav in App.css
  },
  main: {
    // handled by .app-main in App.css
  },
  userArea: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginLeft: 'auto',
  },
  username: {
    fontSize: '12px',
    color: '#555',
    letterSpacing: '0.04em',
  },
  logoutBtn: {
    background: 'transparent',
    border: '1px solid #2a2a3a',
    borderRadius: '6px',
    padding: '4px 12px',
    fontSize: '12px',
    color: '#888',
    cursor: 'pointer',
  },
};